import api from "./api";
import { getServices } from "./servicesCache";

const DRAFT_KEY = "tresses_booking_draft";

// Rebuilds a booking draft from a past booking using current menu prices.
// Returns { target: "/checkout" | "/book", skipped: string[] }.
export async function rebookFromBooking(booking, { userEmail, minAmount = 0 } = {}) {
    if (booking.promotion_id) {
        const promos = await api.get("/promotions").then((r) => r.data || []).catch(() => []);
        const p = promos.find((x) => x.id === booking.promotion_id && x.active && x.type === "package");
        if (p) {
            sessionStorage.setItem(DRAFT_KEY, JSON.stringify({
                selectedIds: p.service_ids || [], selectedPackageIds: [], variantSelections: {}, addonSelections: {},
                promotion_id: p.id, attribution_promotion_id: p.id, owner_email: userEmail ? userEmail.toLowerCase() : null,
            }));
            window.dispatchEvent(new Event("tresses-draft-changed"));
            return { target: `/book?promo=${p.id}`, skipped: [], empty: false };
        }
    }
    const [services, packages] = await Promise.all([
        getServices(),
        api.get("/packages", { params: { active_only: true } }).then((r) => r.data || []).catch(() => []),
    ]);
    const lines = booking.services || [];
    const svcLines = lines.filter((l) => !l.is_package);
    const pkgLines = lines.filter((l) => l.is_package);
    if (!lines.length && booking.service_id) svcLines.push({ id: booking.service_id, name: booking.service_name });

    const skipped = [];
    const selectedIds = [];
    const variantSelections = {};
    const addonSelections = {};
    let subtotal = 0;
    let needsChoice = false;
    svcLines.forEach((l) => {
        const s = services.find((x) => x.id === l.id);
        if (!s) { skipped.push(l.base_name || l.name); return; }
        if (selectedIds.includes(s.id)) return;
        selectedIds.push(s.id);
        const variant = (s.variants || []).find((v) => v.id === l.variant_id);
        if (variant) variantSelections[s.id] = variant.id;
        else if ((s.variants || []).length) needsChoice = true;
        const addonIds = (l.addons || []).map((a) => a.id).filter((id) => (s.addons || []).some((a) => a.id === id));
        if (addonIds.length) addonSelections[s.id] = addonIds;
        subtotal += (variant ? Number(variant.price) : Number(s.price)) + (s.addons || []).filter((a) => addonIds.includes(a.id)).reduce((t, a) => t + Number(a.price || 0), 0);
    });
    const selectedPackageIds = [];
    pkgLines.forEach((l) => {
        const p = packages.find((x) => x.id === l.id);
        if (!p) { skipped.push(l.name); return; }
        selectedPackageIds.push(p.id);
        subtotal += Number(p.price || 0);
    });

    sessionStorage.setItem(DRAFT_KEY, JSON.stringify({
        selectedIds, selectedPackageIds, variantSelections, addonSelections,
        promotion_id: null, owner_email: userEmail ? userEmail.toLowerCase() : null,
    }));
    window.dispatchEvent(new Event("tresses-draft-changed"));

    const empty = !selectedIds.length && !selectedPackageIds.length;
    const ready = !empty && !skipped.length && !needsChoice && subtotal >= minAmount;
    return { target: ready ? "/checkout" : "/book", skipped, empty };
}
